import { React, useState, useContext, useEffect, useMemo } from "react";
import { Flex, Heading, Text, Breadcrumb, Stepper } from "@cisco/spaces-dash-lib-styleguide";
import { AppContext } from "../../contexts/AppContext";
import { PropertiesContext } from "../../contexts/propertiesContext";

function PartnerOnboarding(props) {
  const { isPartnerDashboard: isPartnerDashboardProp, i18n, navigateTo, stepSelected } = props;
  const [isPartnerDashboard, setIsPartnerDashboard] = useState(false);
  const { properties } = useContext(PropertiesContext);
  const [isStepperLeftPaneExpand, setIsStepperLeftPaneExpand] = useState(true);
  const [stepValue, setStepValue] = useState(stepSelected);
  const partnerDashboardYoutubeUrl = properties.partnerDashboardYoutubeUrl ? properties.partnerDashboardYoutubeUrl : "https://www.youtube.com/embed/bD6nQ92t4DQ";
  const partnerOnboardingProcessYoutubeUrl = properties.partnerOnboardingProcessYoutubeUrl ? properties.partnerOnboardingProcessYoutubeUrl : "https://www.youtube.com/embed/DfnOvOMxsQY";
  const iotDeviceMarketplaceYoutubeUrl = properties.iotDeviceMarketplaceYoutubeUrl ? properties.iotDeviceMarketplaceYoutubeUrl : "https://www.youtube.com/embed/lQqWJAb6PB8";
  const iotDeviceMarketplaceSlideshareUrl = properties.iotDeviceMarketplaceSlideshareUrl
    ? properties.iotDeviceMarketplaceSlideshareUrl
    : "https://partner-onboarding-pdfs.s3.amazonaws.com/IDM_Overview.pdf";
  const partnerModelOverviewYoutubeUrl = properties.partnerModelOverviewYoutubeUrl ? properties.partnerModelOverviewYoutubeUrl : "https://www.youtube.com/embed/M3AjodrO68o";
  const modelOverviewSlideshareUrl = properties.modelOverviewSlideshareUrl
    ? properties.modelOverviewSlideshareUrl
    : "https://partner-onboarding-pdfs.s3.amazonaws.com/DNASpaces_and_Partner_Model_Overview.pdf";
  const dashboardAppActivationYoutubeUrl = properties.dashboardAppActivationYoutubeUrl ? properties.dashboardAppActivationYoutubeUrl : "https://www.youtube.com/embed/kN8S9TliInc";

  useEffect(() => {
    console.log("PartnerOnboarding Mount");
    console.log(properties);

    return () => {
      console.log("PartnerOnboarding Destroy");
    };
  }, []);

  useEffect(() => {
    if (isPartnerDashboardProp) {
      setIsPartnerDashboard(true);
    }
  }, [isPartnerDashboardProp, setIsPartnerDashboard]);

  useEffect(() => {
    i18n.loadNamespaces("partners-home");
    i18n.setDefaultNamespace("partners-home");
  }, [i18n]);

  const appContextValue = useMemo(() => ({ isPartnerDashboard }), [isPartnerDashboard]);

  const backTo = (path) => {
    navigateTo(path);
  };

  const stepTitle = () => {
    switch (stepValue) {
      case 1:
        return i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-partner-model-overview-text");
      case 2:
        return i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-dashboard-and-activation-text");
      case 3:
        return i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-text");
      case 4:
        return i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.partner-onboarding-process-text");
      case 5:
        return i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.iot-device-market-place-text");
      default:
        return i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-partner-model-overview-text");
    }
  };

  const stepContent = () => {
    return (
      <Flex direction="vertical">
        {stepValue == 1 && (
          <Flex direction="vertical">
            <Flex>
              {" "}
              <Text size="p3" weight="regular" color="light">
                {i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-partner-model-overview-high-level-text")}
              </Text>
            </Flex>
            <Flex style={{ "margin-top": "20px" }} justify="center">
              {partnerModelOverviewYoutubeUrl && <iframe width="936" height="528" src={partnerModelOverviewYoutubeUrl} title="overview" />}
            </Flex>

            {modelOverviewSlideshareUrl && (
              <Flex style={{ "margin-top": "70px" }}>
                <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.slide-title-text")}</Heading>
              </Flex>
            )}

            {modelOverviewSlideshareUrl && (
              <Flex style={{ "margin-top": "20px" }} justify="center">
                <iframe id="overview-slide" src={modelOverviewSlideshareUrl} width="936" height="506" title="overview slide" />
              </Flex>
            )}
          </Flex>
        )}

        {stepValue == 2 && (
          <Flex direction="vertical">
            <Flex>
              {" "}
              <Text size="p3" weight="regular" color="light">
                {i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.walks-on-spaces-partner-app-activation-text")}
              </Text>
            </Flex>
            <Flex style={{ "margin-top": "20px" }} justify="center">
              {dashboardAppActivationYoutubeUrl && <iframe width="936" height="528" src={dashboardAppActivationYoutubeUrl} title="partner dashboard app activation" />}
            </Flex>
          </Flex>
        )}

        {stepValue == 3 && (
          <Flex direction="vertical">
            <Flex>
              {" "}
              <Text size="p3" weight="regular" color="light">
                {i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.walks-on-documentation-create-apps-text")}
              </Text>
            </Flex>
            <Flex style={{ "margin-top": "20px" }} justify="center">
              {partnerDashboardYoutubeUrl && <iframe width="936" height="528" src={partnerDashboardYoutubeUrl} title="partner dashboard youtube" />}
            </Flex>
          </Flex>
        )}

        {stepValue == 4 && (
          <Flex direction="vertical">
            <Flex>
              {" "}
              <Text size="p3" weight="regular" color="light">
                {i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.walks-on-onboarding-process-text")}
              </Text>
            </Flex>
            <Flex style={{ "margin-top": "20px" }} justify="center">
              {partnerOnboardingProcessYoutubeUrl && <iframe width="936" height="528" src={partnerOnboardingProcessYoutubeUrl} title="market-onboarding" />}
            </Flex>
          </Flex>
        )}

        {stepValue == 5 && (
          <Flex direction="vertical">
            <Flex>
              {" "}
              <Text size="p3" weight="regular" color="light">
                {i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.high-level-of-spaces-iot-device-market-place-text")}
              </Text>
            </Flex>
            <Flex style={{ "margin-top": "20px" }} justify="center">
              {iotDeviceMarketplaceYoutubeUrl && <iframe width="936" height="528" src={iotDeviceMarketplaceYoutubeUrl} title="market-youtube" />}
            </Flex>

            {iotDeviceMarketplaceSlideshareUrl && (
              <Flex style={{ "margin-top": "70px" }}>
                <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.slide-title-text")}</Heading>
              </Flex>
            )}

            {iotDeviceMarketplaceSlideshareUrl && (
              <Flex style={{ "margin-top": "20px" }} justify="center">
                <iframe src={iotDeviceMarketplaceSlideshareUrl} width="936" height="506" title="market-slide" />
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
    );
  };

  return (
    <AppContext.Provider value={appContextValue}>
      <Breadcrumb style={{ margin: "10px" }}>
        <Breadcrumb.Link
          id="home-link"
          onClick={() => {
            backTo("/");
          }}
        >
          {i18n.t("partner-dashboard-app.partner-apps.app-center.home-text")}
        </Breadcrumb.Link>
        <Breadcrumb.Link>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-onboarding-text")}</Breadcrumb.Link>
      </Breadcrumb>
      <Flex style={{ margin: "20px", height: "100%" }} direction="vertical" id="on-boarding-stepper">
        <Stepper workflowTitle={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.spaces-partner-onboarding-text")}>
          <Stepper.LeftPanel
            isExpanded={isStepperLeftPaneExpand}
            expandedWidth={450}
            onCollapse={() => {
              setIsStepperLeftPaneExpand((prevIsStepperLeftPaneExpand) => !prevIsStepperLeftPaneExpand);
            }}
            onExpand={() => {
              setIsStepperLeftPaneExpand((prevIsStepperLeftPaneExpand) => !prevIsStepperLeftPaneExpand);
            }}
          >
            <Stepper.Step
              active={stepValue == 1}
              expanded={isStepperLeftPaneExpand}
              expandedWidth={450}
              onClick={() => {
                setStepValue(1);
              }}
              stepNumber={1}
              title={i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-partner-model-overview-text")}
            />
            <Stepper.Step
              active={stepValue == 2}
              expanded={isStepperLeftPaneExpand}
              expandedWidth={450}
              onClick={() => {
                setStepValue(2);
              }}
              stepNumber={2}
              title={i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.spaces-dashboard-and-activation-text")}
            />
            <Stepper.Step
              active={stepValue == 3}
              expanded={isStepperLeftPaneExpand}
              expandedWidth={450}
              onClick={() => {
                setStepValue(3);
              }}
              stepNumber={3}
              title={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-text")}
            />
            <Stepper.Step
              active={stepValue == 4}
              expanded={isStepperLeftPaneExpand}
              expandedWidth={450}
              onClick={() => {
                setStepValue(4);
              }}
              stepNumber={4}
              title={i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.partner-onboarding-process-text")}
            />
            <Stepper.Step
              active={stepValue == 5}
              expanded={isStepperLeftPaneExpand}
              expandedWidth={450}
              onClick={() => {
                setStepValue(5);
              }}
              stepNumber={5}
              title={i18n.t("partner-dashboard-app.partner-apps.partner-onboarding.iot-device-market-place-text")}
            />
          </Stepper.LeftPanel>
          <Stepper.RightPanel
            content={stepContent()}
            isTertiaryActionAvailable={stepValue > 1}
            isPrimaryActionDisabled={stepValue >= 5}
            isPrimaryActionAvailable={false}
            isSecondaryActionAvailable={false}
            primaryAction={() => {
              setStepValue(stepValue + 1);
            }}
            secondaryAction={() => {
              backTo("/");
            }}
            tertiaryAction={() => {
              setStepValue(stepValue - 1);
            }}
            stepTitle={stepTitle()}
          />
        </Stepper>
      </Flex>
    </AppContext.Provider>
  );
}

export default PartnerOnboarding;
